import api from './api';

const API_URL = '/recipes'; 

// Obtener todas las recetas
export const getAllRecipes = async (storeId) => {
  try {
    const response = await api.get(API_URL, { params: { storeId } });
    return response.data;
  } catch (error) {
    console.error('Error fetching recipes:', error);
    throw error;
  }
};

// Obtener una receta por ID
export const getRecipeById = async (id, storeId) => {
  try {
    const response = await api.get(`${API_URL}/${id}`, { 
      params: { storeId } 
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching recipe:', error);
    throw error;
  }
};

// Crear receta
export const createRecipe = async (recipeData) => {
  try {
    const response = await api.post(API_URL, recipeData);
    return response.data;
  } catch (error) {
    console.error('Error creating recipe:', error);
    throw error;
  }
};

// Actualizar receta
export const updateRecipe = async (id, recipeData) => {
  try {
    const response = await api.put(`${API_URL}/${id}`, recipeData);
    return response.data;
  } catch (error) {
    console.error('Error updating recipe:', error);
    throw error;
  }
};

// Eliminar receta
export const deleteRecipe = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting recipe:', error);
    throw error;
  }
};